import { isEmpty } from "lodash";
import Link from "next/link";
import { FC, useEffect, useMemo, useState } from "react";
import Button from "~/components/Button";
import Select from "~/components/Select";
import Text from "~/components/Text";
import { AvailableRegions, CountriesAtom, Country } from "~/services/countries";
import ModalContainer from "../ModalContainer";
import { useSetRecoilState } from "recoil";

interface ChooseCountryModalProps {
  open?: boolean;
  onConfirm?: (countrySelected: Country, region?: any) => void;
  loading?: boolean;
  onCancel?: () => void;
  country: Country;
  region: AvailableRegions;
  countries: Country[];
}

const ChooseCountryModal: FC<ChooseCountryModalProps> = ({
  onCancel,
  open,
  onConfirm,
  loading,
  country,
  region,
  countries,
}) => {
  const [countryState, setSelected] = useState<Country>(country as Country);
  const [regionState, setRegion] = useState<any>({
    ...region,
    value: region?.code || "",
    label: region?.name || "",
  });
  // const [regionError, setRegionError] = useState<string>("")

  const avalidRegions: any[] = useMemo(() => {
    if (!countryState.value) return [];

    const result =
      countries?.find((c: Country) => c.value === countryState?.value)
        ?.available_regions || [];

    if (!!result?.length && !isEmpty(regionState)) {
      setRegion({});
    }
    return (
      result?.map((r: any) => ({ label: r.name, value: r.code, id: r.id })) ||
      []
    );
  }, [countries, countryState]);

  const handleConfirm = () => {
    // if(!!avalidRegions.length && isEmpty(regionState)){
    //   setRegionError("Please choosen region")
    //   return
    // }
    onConfirm?.(countryState, {
      id: regionState?.id,
      code: regionState?.value,
      name: regionState?.label,
    });
  };

  useEffect(() => {
    if (open) {
      setSelected(country);
      setRegion({
        ...region,
        value: region?.code || "",
        label: region?.name || "",
      });
    }
  }, [open]);

  return (
    <ModalContainer
      open={open}
      title="Choose country"
      onClose={onCancel}
      type="bottom-sheet"
      className="!overflow-visible "
    >
      <div className="flex flex-col gap-6 ">
        <Select
          required
          options={countries || []}
          label="Country"
          value={countryState?.value}
          onChange={(e, options: any) => {
            setSelected(options);
          }}
        />
        {!isEmpty(avalidRegions) && (
          <Select
            options={avalidRegions}
            label="Region"
            value={regionState?.value || ""}
            onChange={(e, options: any) => {
              setRegion(options);
            }}
          />
        )}
      </div>
      <div>
        <Text>
          Learn more about our{" "}
          <Link href={"/shipping-policy"} className="underline">
            Shipping Policy
          </Link>
        </Text>
      </div>
      <div className="flex gap-5 py-5 sticky bottom-0 bg-white">
        <Button
          className="flex-1"
          variant="secondary"
          type="outline"
          onClick={onCancel}
        >
          Cancel
        </Button>
        <Button
          disabled={loading}
          className="flex-1"
          onClick={handleConfirm}
          loading={loading}
        >
          Save Changes
        </Button>
      </div>
    </ModalContainer>
  );
};

export default ChooseCountryModal;
